import React from 'react';
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Switch,
  Typography,
  Divider,
} from '@mui/material';
import { WaField, optionalLabel } from '../whatsappPreview';
import { FlowComponent } from '../../../../flow-core/FlowComponent';
import { TextInputCore } from '../../../../flow-core/components/TextInputCore';

export const TextInputComponent = new FlowComponent({
  ...TextInputCore,
  renderPreview(properties) {
    return (
      <WaField
        typeable
        label={optionalLabel(properties.label || 'Enter text', properties.required)}
        helper={properties['helper-text']}
        properties={properties}
      />
    );
  },
  renderPropertyEditor(properties, onChange) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          fullWidth
          label="Field Name"
          value={properties.name || ''}
          onChange={(e) => onChange('name', e.target.value)}
          required
          size="small"
          helperText="Used to identify this field in the form data"
        />

        <TextField
          fullWidth
          label="Label"
          value={properties.label || ''}
          onChange={(e) => onChange('label', e.target.value)}
          required
          size="small"
          helperText={`${(properties.label || '').length}/80 characters`}
        />

        <FormControl fullWidth size="small">
          <InputLabel>Input Type</InputLabel>
          <Select
            value={properties['input-type'] || 'text'}
            onChange={(e) => onChange('input-type', e.target.value)}
            label="Input Type"
          >
            <MenuItem value="text">Text</MenuItem>
            <MenuItem value="number">Number</MenuItem>
            <MenuItem value="email">Email</MenuItem>
            <MenuItem value="password">Password</MenuItem>
            <MenuItem value="phone">Phone</MenuItem>
          </Select>
        </FormControl>

        <TextField
          fullWidth
          label="Initial Value"
          value={properties['init-value'] || ''}
          onChange={(e) => onChange('init-value', e.target.value)}
          size="small"
          helperText="Pre-populated value when the form loads"
        />

        <TextField
          fullWidth
          label="Helper Text"
          value={properties['helper-text'] || ''}
          onChange={(e) => onChange('helper-text', e.target.value)}
          size="small"
          helperText="Optional text shown below the input field"
        />

        <Divider sx={{ my: 1 }} />
        <Typography variant="subtitle2" color="text.secondary">
          Validation
        </Typography>

        <FormControlLabel
          control={
            <Switch
              checked={properties.required || false}
              onChange={(e) => onChange('required', e.target.checked)}
            />
          }
          label="Required"
        />

        <Box sx={{ display: 'flex', gap: 1 }}>
          <TextField
            label="Min Characters"
            type="number"
            value={properties['min-chars'] || ''}
            onChange={(e) => onChange('min-chars', e.target.value)}
            size="small"
            sx={{ flex: 1 }}
            inputProps={{ min: 0 }}
          />
          <TextField
            label="Max Characters"
            type="number"
            value={properties['max-chars'] || ''}
            onChange={(e) => onChange('max-chars', e.target.value)}
            size="small"
            sx={{ flex: 1 }}
            inputProps={{ min: 1, max: 80 }}
            helperText="Default: 80"
          />
        </Box>

        <TextField
          fullWidth
          label="Pattern (Regex)"
          value={properties.pattern || ''}
          onChange={(e) => onChange('pattern', e.target.value)}
          size="small"
          helperText="Regular expression for validation (v6.2+)"
        />

        <TextField
          fullWidth
          label="Error Message"
          value={properties['error-message'] || ''}
          onChange={(e) => onChange('error-message', e.target.value)}
          size="small"
          helperText="Custom error message when validation fails"
        />

        <Divider sx={{ my: 1 }} />
        <Typography variant="subtitle2" color="text.secondary">
          State
        </Typography>

        <FormControlLabel
          control={
            <Switch
              checked={properties.enabled !== false}
              onChange={(e) => onChange('enabled', e.target.checked)}
            />
          }
          label="Enabled"
        />

        <FormControlLabel
          control={
            <Switch
              checked={properties.visible !== false}
              onChange={(e) => onChange('visible', e.target.checked)}
            />
          }
          label="Visible"
        />
      </Box>
    );
  },
});
